import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { Table } from 'semantic-ui-react';
import { parseTimestamp } from 'helpers/DateHandler';
import store from 'reduxStore/store';
import PriceWithExchangeRatePopup from '../PriceWithExchangeRatePopup';
import { useTokenization } from 'providers/TokenizationProvider';
const AssignmentInfoDisplay = ({ assignment }) => {
    const { t } = useTranslation('common');
    const { exchangeRate } = store.getState().userProfile;
    const { isTokenizationEnabled } = useTokenization();
    function langugageString(sourceLang, targetLang) {
        return sourceLang == targetLang
            ? t(`languages.${sourceLang.toLowerCase()}`)
            : `${t(`languages.${sourceLang.toLowerCase()}`)} → ${t(`languages.${targetLang.toLowerCase()}`)}`;
    }
    return React.createElement(React.Fragment, null,
        React.createElement(Table, { basic: "very", collapsing: true, compact: "very" },
            React.createElement(Table.Body, null,
                assignment.executor && React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null, t('dashboard.executor')),
                    React.createElement(Table.Cell, null, assignment.executor)),
                assignment.assigner && React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null, t('dashboard.buyerName')),
                    React.createElement(Table.Cell, null, assignment.assigner)),
                React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null, t('dashboard.stageType')),
                    React.createElement(Table.Cell, null, t(`dashboard.${assignment.stageType}`))),
                assignment.jobLangFrom && assignment.jobLangTo && React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null, t('dashboard.jobLanguages')),
                    React.createElement(Table.Cell, null, langugageString(assignment.jobLangFrom, assignment.jobLangTo))),
                assignment.genre && React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null, t('dashboard.genre')),
                    React.createElement(Table.Cell, null, t(`genre.${assignment.genre}`))),
                assignment.gatedCommunities && assignment.gatedCommunities.length > 0 && React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null, t('gatedCommunities.gatedCommunity')),
                    React.createElement(Table.Cell, null, assignment.gatedCommunities.join(', '))),
                React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null, t('dashboard.uploadDate')),
                    React.createElement(Table.Cell, null, parseTimestamp(assignment.uploadDate))),
                React.createElement(Table.Row, { error: moment(assignment.dueDate).isBefore() },
                    React.createElement(Table.Cell, null, t('dashboard.dueDate')),
                    React.createElement(Table.Cell, null, parseTimestamp(assignment.dueDate))),
                React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null,
                        " ",
                        t('dashboard.claimDate')),
                    React.createElement(Table.Cell, null, parseTimestamp(assignment.claimDate))),
                assignment.deliveryDate && React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null, t('dashboard.deliveryDate')),
                    React.createElement(Table.Cell, null, parseTimestamp(assignment.deliveryDate))),
                assignment.price !== undefined && React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null, t('dashboard.estimatedPrice')),
                    React.createElement(Table.Cell, null,
                        React.createElement(PriceWithExchangeRatePopup, { cost: assignment.price, customCurrencyCost: assignment.userCurrencyPrice, exchangeRate: exchangeRate }))),
                isTokenizationEnabled && assignment.cxfl !== null && assignment.cxfl !== undefined && React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null, t('dashboard.earnedLangCoin')),
                    React.createElement(Table.Cell, null, assignment.cxfl / 100)),
                assignment.progress !== undefined && React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null, t('dashboard.doneIn')),
                    React.createElement(Table.Cell, null,
                        Math.floor(assignment.progress * 100),
                        " %")))));
};
export default AssignmentInfoDisplay;
